import {
  POSP_DATA,
  POSP_BIKENUM,
  Posp_DETAILS,
  LOGOUT_POSP,
  Posp_SINGLE_QUOTE,
  SAVE_PASS,
  ONBOARD_OTP_DATA,
  LOGIN_OBOARD,
  ONBOARD_DETAILS,
  ONBOARD_DOC_DETAILS,
  LOG_STATE,
} from "../actiontypes/NumBikeActiontypes";

const init = {
  Posp: {},
  Pospnum: {},
  PospDetails: {},
  PospViewQuote: {},
  onboardOtp: {},
  onbNum: {},
  onbDetails: {},
  onbDocs: {},
  isChangePass: false,
};
const InitPass = {
  rememberedEmail: "",
  rememberedPassword: "",
};
export const PospReducer = (state = init, { type, payload }) => {
  switch (type) {
    case POSP_DATA:
      return { ...state, Posp: payload, isChangePass: false };
    case LOG_STATE:
      return { ...state, isChangePass: true };
    case POSP_BIKENUM:
      return { ...state, Pospnum: payload };
    case Posp_DETAILS:
      return { ...state, PospDetails: payload };
    case Posp_SINGLE_QUOTE:
      return { ...state, PospViewQuote: payload };
    case ONBOARD_OTP_DATA:
      return { ...state, onboardOtp: payload };
    case LOGIN_OBOARD:
      return { ...state, onbNum: payload };
    case ONBOARD_DETAILS:
      return { ...state, onbDetails: payload };
    case ONBOARD_DOC_DETAILS:
      return { ...state, onbDocs: payload };
    case LOGOUT_POSP:
      return init;
    default:
      return { ...state };
  }
};
export const PassReducer = (state = InitPass, { type, payload }) => {
  switch (type) {
    case SAVE_PASS:
      return {
        ...state,
        rememberedEmail: payload.Email,
        rememberedPassword: payload.Password,
      };
    default:
      return { ...state };
  }
};
